import types from '../constants/actionTypes';

export function editUser(id) {
  return {
    type: types.users.REQUEST_EDIT_USER,
    userId: id,
  };
};

export function cancelEdit(id) {
  return {
    type: types.users.CANCEL_EDIT_USER,
    userId: id,
  };
};

export function addUser(id) {
  return {
    type: types.users.REQUEST_ADD_USER,
  };
};

export function cancelAddUser(id) {
  return {
    type: types.users.CANCEL_ADD_USER,
  };
};

export function changeNewUserAttribute(attribute, value) {
  return {
    type: types.users.CHANGE_NEW_USER_ATTRIBUTE,
    attribute: attribute,
    value: value,
  };
};



/** WEBPACK FOOTER **
 ** ./actions/users.js
 **/